import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { bootstrap } from './store/chat';
import { trackVisualViewport } from './lib/viewport';
import { handleCallLink } from './calls/callManager';
import { primeSounds } from './lib/sound';
import './styles.css';

// Opened from a call notification: remember an "answer" request and clean the URL.
if (location.search.includes('call=')) history.replaceState(null, '', handleCallLink(location.href));
trackVisualViewport();
primeSounds();
void bootstrap();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
